import {
  getIECViewData,
  addIECModuleAPI,
  updateIECModuleSuperAdmin,
} from "../../Services/IECModuleService";
import { parseIECdata } from "../../Shared/Utils/BackendPaeser";
export const SET_IEC_DATA = "SET_IEC_DATA";
export const FETCH_IECVIEW_DATA_SUCCESS = "FETCH_TOTAL_ASHA_ANM_DATA_SUCCESS";
export const FETCH_IECVIEW_DATA_FAILURE = "FETCH_TOTAL_ASHA_ANM_DATA_FAILURE";
export const ADD_IEC_DATA_SUCCESS = "ADD_IEC_DATA_SUCCESS";
export const ADD_IEC_DATA_FAILURE = "ADD_IEC_DATA_FAILURE";
export const ADD_IEC_DATA = "ADD_IEC_DATA";
export const UPDATE_IEC_DATA = "UPDATE_IEC_DATA";
export const UPDATE_IEC_DATA_SUCCESS = "UPDATE_IEC_DATA_SUCCESS";
export const UPDATE_IEC_DATA_FAILURE = "UPDATE_IEC_DATA_FAILURE";
export const CLEAR_SELECTED_ITEMS = "CLEAR_SELECTED_ITEMS";
export const SELECT_IEC_ITEMS = "SELECT_IEC_ITEMS";

export const clearSelectedItems = () => ({
  type: CLEAR_SELECTED_ITEMS,
});
export const selectIECItems = (items) => ({
  type: SELECT_IEC_ITEMS,
  payload: items,
});

export const fetchIECViewData = (dispatch, selectedLanguageId) => {
  return async () => {
    try {
      const responseData = await getIECViewData(selectedLanguageId);
      const parsedData = parseIECdata(responseData);
      dispatch({
        type: "SET_IEC_DATA",
        payload: parsedData,
      });
    } catch (error) {
      console.error("fetchIECViewData error:", error);
    }
  };
};

export const addIECModule = ({
  type,
  audience,
  title,
  description,
  uploadFile,
  dispatch2,
  selectedLanguageId,
  translatedTitle,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_IEC_DATA });
    try {
      const audienceJSON = JSON.stringify(audience);
      const formData = new FormData();
      formData.append("video", uploadFile);
      formData.append("category", type);
      formData.append("audience", audienceJSON);
      formData.append("eng_title", title);
      formData.append("description", description);
      formData.append("mar_title", translatedTitle);
      const response = await addIECModuleAPI(formData);
      dispatch({ type: ADD_IEC_DATA_SUCCESS, payload: response.data });
      await fetchIECViewData(dispatch2, selectedLanguageId)();
      dispatch(clearSelectedItems());
    } catch (error) {
      dispatch({ type: ADD_IEC_DATA_FAILURE, payload: error });
    }
  };
};
export const updateIECModule = ({
  updateId,
  type,
  audience,
  title,
  description,
  uploadFile,
  dispatch2,
  selectedLanguageId,
  translatedTitle,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_IEC_DATA });
    try {
      const data = await updateIECModuleSuperAdmin(
        updateId,
        type,
        audience,
        title,
        description,
        uploadFile,
        translatedTitle
      );
      dispatch({ type: UPDATE_IEC_DATA_SUCCESS, payload: data });
      await fetchIECViewData(dispatch2, selectedLanguageId)();
      dispatch(clearSelectedItems());
    } catch (error) {
      dispatch({ type: UPDATE_IEC_DATA_FAILURE, payload: error });
    }
  };
};
